import { render } from "./InvoiceReport.vue?vue&type=template&id=b7c57124"
import script from "./InvoiceReport.vue?vue&type=script&lang=js"
export * from "./InvoiceReport.vue?vue&type=script&lang=js"

import exportComponent from "/Users/souban/Documents/Code/Pitch/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__